import React, { useState } from 'react';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import { useParams } from 'react-router-dom';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import TableRowAction from 'components/common/TableRowAction';
import dayjs from 'dayjs';
import SelectStudentModal from '../school/SelectStudentModal';
import {
  useHospitalOrphans,
  useCreateHospitalOrphan,
  useDeleteHospitalOrphan
} from 'hooks/useBeneficiaries';

const OrphanTable = () => {
  const { id } = useParams();
  const [showStudentAddModal, setShowStudentAddModal] = useState(false);

  const { hospitalOrphans, isLoading: loading } = useHospitalOrphans(id);
  const { createHospitalOrphanAsync, isCreating: addLoading } =
    useCreateHospitalOrphan();
  const { deleteHospitalOrphanAsync } = useDeleteHospitalOrphan();

  const calculateAge = DOB => {
    const birthDate = dayjs(DOB);
    const currentDate = dayjs();
    const age = currentDate.diff(birthDate, 'year');
    return age;
  };

  const removeStudent = async orphanId => {
    try {
      await deleteHospitalOrphanAsync(orphanId);
    } catch (error) {
      console.error('Error deleting hospital orphan:', error);
    }
  };

  const columns = [
    {
      accessor: 'full_name',
      Header: 'Name',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { first_name, last_name } = rowData.row.original;
        return <>{first_name + ' ' + last_name}</>;
      }
    },
    {
      accessor: 'DOB',
      Header: 'Age',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { DOB } = rowData.row.original;
        return <>{calculateAge(DOB)}</>;
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { gender } = rowData.row.original;
        return <>{gender}</>;
      }
    },
    {
      accessor: 'created_at',
      Header: 'Registration',
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return <>{dayjs(created_at).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'inspiration',
      Header: 'Aspiration',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { inspiration } = rowData.row.original;
        return <>{inspiration}</>;
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return <>{status}</>;
      }
    },
    {
      accessor: 'id_',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <TableRowAction
            onCLickDelete={() => removeStudent(id)}
            isNotEdit
            subject={permissionsKeyMap.facilities.children.hospital}
          />
        );
      }
    }
  ];

  const submitStudent = async value => {
    try {
      await createHospitalOrphanAsync({
        hospital_id: id,
        orphan_id: value
      });
      setShowStudentAddModal(false);
    } catch (error) {
      console.error('Error adding hospital orphan:', error);
    }
  };

  return (
    <>
      {!loading && (
        <CustomAdvanceTable
          loading={loading}
          data={
            hospitalOrphans?.map((student, index) => ({
              ...student?.orphan,
              key: `${student?.orphan?.id}-${index}`
            })) || []
          }
          columns={columns}
          title="Orphans"
          addButtonLabel="Add Students"
          addButtonIcon="user"
          onClickAddNew={() => {
            setShowStudentAddModal(true);
          }}
          addNew
          subject={permissionsKeyMap.facilities.children.hospital}
        />
      )}

      <SelectStudentModal
        show={showStudentAddModal}
        onHide={() => setShowStudentAddModal(false)}
        onSubmit={submitStudent}
        addLoading={addLoading}
      />
    </>
  );
};

export default OrphanTable;
